import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AuthSignOut } from 'domain/usecases';

export class RemoteAuthSignOut implements AuthSignOut {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<AuthSignOut.Result>,
  ) {}

  async execute(params: AuthSignOut.Params): Promise<AuthSignOut.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: this.url,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
